import React from 'react';
import { Container } from '../../components/ui/Container';
export function ChildSafeguardingPolicy() {
  return <>
      <section className="py-16 md:py-24" data-id="element-3788" data-mp="163dyr3nlxk3">
        <Container data-id="element-3789" data-mp="1991w30jqte8">
          <div className="max-w-4xl mx-auto" data-id="element-3790" data-mp="f6eaa9nqg4cn">
            <h1 className="font-display text-4xl md:text-6xl text-ink-900 leading-tight" data-id="element-3791" data-mp="f64h6d7e5h2q">
              Child Safeguarding Policy
            </h1>
            <p className="mt-4 text-ink-500" data-id="element-3792" data-mp="3jkmeb49fz3k1">
              <strong data-id="element-3793" data-mp="3jldylixl9ev0">Last updated:</strong> February 1, 2026
            </p>

            <div className="mt-10 space-y-8 text-ink-700 leading-relaxed" data-id="element-3794" data-mp="3emucniizw32n">
              <p data-id="element-3795" data-mp="3scxvdzio1enc">
                The <strong data-id="element-3796" data-mp="3se7tgopiqmtz">International Islamic Learning Hub (IILH)</strong>{' '}
                is unequivocally committed to safeguarding and promoting the
                welfare of children. The safety, dignity, and well-being of
                children are our highest priorities.
              </p>

              <h2 className="font-display text-2xl md:text-3xl text-ink-900 mt-12" data-id="element-3797" data-mp="2vu8n1fyol8qi">
                Standards and Activities
              </h2>
              <p data-id="element-3798" data-mp="3l2na14wfh4cq">
                All activities, whether online or offline, involving minors are
                conducted in strict adherence to international safeguarding
                standards.
              </p>

              <h2 className="font-display text-2xl md:text-3xl text-ink-900 mt-12" data-id="element-3799" data-mp="3nqafm2xjdh6">
                Safeguarding Measures
              </h2>
              <p data-id="element-3800" data-mp="326x5b9x41tv5">
                We implement the following measures to ensure a safe
                environment:
              </p>
              <p data-id="element-3801" data-mp="376t1wo3haj0o">
                <strong data-id="element-3802" data-mp="3c3t952c2drtd">• Content:</strong> Delivery of age-appropriate
                educational content.
              </p>
              <p data-id="element-3803" data-mp="3h362m5xfxx4x">
                <strong data-id="element-3804" data-mp="3h3nvcskw9t83">• Supervision:</strong> Active supervision and
                moderation in all online environments and forums.
              </p>
              <p data-id="element-3805" data-mp="wcni6v9ilrvo">
                <strong data-id="element-3806" data-mp="wc5j7qvgwzk2">• Boundaries:</strong> Maintenance of clear,
                professional boundaries between adults (staff/educators) and
                children at all times.
              </p>
              <p data-id="element-3807" data-mp="2nhi9dlw1mhd8">
                <strong data-id="element-3808" data-mp="2nfxefv5tgweu">• Training:</strong> Mandatory safeguarding training for
                all staff and educators.
              </p>

              <h2 className="font-display text-2xl md:text-3xl text-ink-900 mt-12" data-id="element-3809" data-mp="31e5jkqd0b413">
                Zero Tolerance
              </h2>
              <p data-id="element-3810" data-mp="29osnrikffegn">
                The organization maintains a{' '}
                <strong data-id="element-3811" data-mp="29mxy5qy7my68">zero-tolerance policy</strong> regarding abuse,
                exploitation, harassment, or neglect of children.
              </p>

              <h2 className="font-display text-2xl md:text-3xl text-ink-900 mt-12" data-id="element-3812" data-mp="2iifgeztc81lm">
                Reporting Concerns
              </h2>
              <p data-id="element-3813" data-mp="2dp2reokqxssc">
                If you have any concerns regarding the safety of a child or the
                conduct of a staff member, you must report it immediately.
              </p>
              <p data-id="element-3814" data-mp="1lxn936q82s7x">
                <strong data-id="element-3815" data-mp="1bvszm9nwdkkr">Contact:</strong>{' '}
                <a href="mailto:safeguarding@iilh.org" className="text-forest-700 underline hover:text-forest-800" data-id="element-3816" data-mp="1bv138wmh7itf">
                  safeguarding@iilh.org
                </a>
              </p>
              <p data-id="element-3817" data-mp="11vsd6euqeocc">
                <strong data-id="element-3818" data-mp="16wgcdnt46bhn">Handling:</strong> All reports are treated with the
                utmost confidentiality and seriousness.
              </p>
            </div>
          </div>
        </Container>
      </section>
    </>;
}